import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { PlatformReferralRoute } from '/@/modules/platformreferral/constants/PlatformReferralRoutes';

export class ReferralPageUrlService extends BaseService {
  getUrl(referralId) {
    return `${window.location.origin}/${PlatformReferralRoute.VIEWS.path}/${PlatformReferralRoute.FREE_WILL_REFERRALS.path}/${referralId}`;
  }
}

export default new ReferralPageUrlService();
